export const theme = {
    primaryDark: '#0D0C1D',
    primaryLight: '#ffffff',
    primaryHover: '#343078',
    primaryMenuColor: '#7258db',
    primaryActiveColor: '#ffd55d',
    mobile: '576px',
    tablet: '1024px',
}